<template>
    <div>
        <v-toolbar flat dense app color="primary" dark>
            <v-toolbar-side-icon @click.stop="drawer()"></v-toolbar-side-icon>
            <v-toolbar-title>Registrar</v-toolbar-title>
        </v-toolbar>

        <v-list v-if="caixa">
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-sub-title>MAC</v-list-tile-sub-title>
                    <v-list-tile-title>{{caixa.mac}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile >
                <v-list-tile-content>
                    <v-list-tile-sub-title>SLOT / PON</v-list-tile-sub-title>
                    <v-list-tile-title>PON: {{ caixa.pon }} SLOT: {{ caixa.slot }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>
        </v-list>

        <v-layout row grid-list-md v-if="caixa">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>FABRICANTE</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="all_fabricantes"
                        v-model="caixa.fabricante"
                        item-text="nome"
                        item-value="nome"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row grid-list-md v-if="caixa">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>TIPO DE INSTALAÇÃO</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="tipos"
                        v-model="caixa.tipo"
                        item-text="nome"
                        item-value="_id"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row grid-list-md v-if="caixa && caixa.tipo === 'FTTC'">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>PAC PON</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="all_caixas"
                        v-model="caixa._id"
                        item-text="nome"
                        item-value="_id"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row grid-list-md v-if="caixa && caixa.tipo === 'FTTH'">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>CTO</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="ctos"
                        v-model="caixa.cto_id"
                        item-text="nome"
                        item-value="_id"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row grid-list-md v-if="caixa && caixa.tipo === 'FTTH'">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>CLIENTE</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="ordens"
                        v-model="caixa.contrato_id"
                        item-text="nome_cliente"
                        item-value="id_contratos_servicos"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row v-if="caixa">
            <v-flex xs12 pa-3>
                <v-btn block small color="primary" :disabled="!caixa.tipo || ((caixa.tipo === 'FTTC' && !caixa._id) || (caixa.tipo === 'FTTH' && ! caixa.contrato_id)) || !caixa.fabricante" @click.native="add">
                    {{ textButton }}
                </v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus.js"
    import { Ordens } from "../../class/ordens";

    export default {
        name: "Registrar",
        data () {
            return {
                search_text: null,
                textButton: "ATIVAR ONU",
                disabled: false,
                iconClass: "white--text",
                search: false,
                all_fabricantes: [
                    {
                        nome: "INTELBRAS"
                    },
                    {
                        nome: "OUTROS"
                    }
                ],
                tipos: [
                    {
                        nome: "FTTH"
                    },
                    {
                        nome: "FTTC"
                    }
                ],
                ctos: [],
                ordens: null,
                all_caixas: [],
                caixa: null
            }
        },
        /*
        computed: {
            ordens () {
                return this.$store.state.ordens;
            }
        },
        */
        async beforeMount () {
            if (this.$route.params.mac) {
                this.load(this.$route.params.mac)
            }
            this.ordens = await Ordens.getAll();
        },
        /*
        mounted () {
            console.log(this.ordens);
        },
         */
        methods: {
            load (mac) {
                Caixas.unregistered()
                    .then(ordens => {
                        let caixas = ordens.data.onus;
                        caixas.forEach((c) => {
                            if (c.mac === mac) {
                                this.caixa = c;
                                this.loadCaixasByPon(c.slot, c.pon);
                                this.loadCtosByPon(c.slot, c.pon);
                            }
                        })
                    })
                    .catch((err) => console.error(err))
            },
            loadCaixasByPon (slot, numero) {
                Caixas.caixasByPon(slot, numero)
                    .then(res => {
                        this.all_caixas = res.data;
                    })
                    .catch((err) => console.error(err))
            },
            loadCtosByPon (slot, numero) {
                Caixas.allCtosByPon(slot, numero)
                    .then(res => {
                        this.ctos = res.data;
                    })
                    .catch((err) => console.error(err))
            },
            async add () {
                try {
                    this.textButton = "Registrando";
                    if (! this.disabled) {
                        this.disabled = true;
                        await Caixas.registrar(this.caixa);
                        this.goTo();
                    }
                } catch (e) {
                    console.error(e);
                    alert("Problemas para registrar.\nPor favor repita a operação!");
                    this.goTo();
                }
            },
            drawer: () => {
                EventBus.$emit("drawer", true)
            },
            goTo () {
                this.$router.push("/onus-unregistered")
            }
        }
    }
</script>

<style scoped>

</style>
